import { Box, Image, ChakraProvider } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import LoginForm1 from "./components/LoginForm1";
import LoginForm2 from "./components/LoginForm2";
import LoginForm3 from "./components/LoginForm3";
import LoginForm4 from "./components/LoginForm4";
import Main from "../../assets/images/bg-auth-overlay 1.svg";
import logo from "../../assets/images/Inca-Logo-WHite 1.svg";
import LoginConfirmation from "./components/LoginConfirmation";
import { Provider } from "react-redux";
import store from "./Store";
import InitialPage from "./components/InitialPage";
function Register() {
  const [step, setStep] = useState(0);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const nextStep = () => {
    setStep((pre) => {
      if (pre >= steps.length) {
        return pre;
      } else {
        return pre + 1;
      }
    });
  };
  const prevStep = () => {
    setStep((pre) => {
      if (pre <= 0) {
        return pre;
      } else {
        return pre - 1;
      }
    });
  };
  const steps = [
    {
      content: <InitialPage nextStep={nextStep} />,
    },
    {
      content: <LoginForm1 nextStep={nextStep} />,
    },
    {
      content: <LoginForm3 prevStep={prevStep} nextStep={nextStep} />,
    },
    {
      content: <LoginForm2 nextStep={nextStep} prevStep={prevStep} />,
    },
    {
      content: <LoginForm4 nextStep={nextStep} prevStep={prevStep} />,
    },
    {
      content: <LoginConfirmation prevStep={prevStep} />,
    },
  ];

  const updateWindowHeight = () => {
    setWindowHeight(window.innerHeight);
  };

  useEffect(() => {
    // Add event listener for window resize
    window.addEventListener("resize", updateWindowHeight);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", updateWindowHeight);
    };
  }, []);

  return (
    <Provider store={store}>
    <ChakraProvider>
      <Box overflow={"auto"} h="100vh">
        <Box
          py="15px"
          px="20px"
          bg="#2A3042"
          display={{ sm: "block", xl: "none" }}>
          <Box>
            <Image src={logo} />
          </Box>
        </Box>
        <Box
          mt={{ base: "20px", sm: "40px", xl: "0px" }}
          alignItems={"center"}
          display={{base:"block",xl:"flex"}}
          fontFamily="sans-serif">
          <Box
            width="30%"
            h={{base:"auto",xl:"100vh"}}
            bg="#2A3042"
            color="white"
            display={{ base: "none", xl: "block" }}>
            <Image objectFit="cover" src={Main} />
            <Box w="80%" mx="auto">
              <Box display="flex" gap="30px" flexDirection="column">
                <Image src={logo} w="160px" />
                <Box display="flex" gap="20px" flexDirection="column">
                  <Box fontSize="26px" fontWeight="700" lineHeight="26px">
                    Fast, reliable, secure.
                  </Box>
                  <Box fontSize="16px">
                    Welcome to inca, the easiest way to text your customers.
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box  width={{base:"100%",xl:"70%"}} py="20px"  display={windowHeight >650 ?"flex":""} alignItems="center" h={{base:"auto",xl:"100vh"}} overflow={"auto"}>
              {steps[step].content}
          </Box>
        </Box>
      </Box>
    </ChakraProvider>
    </Provider>
  );
}

export default Register;
